import { Component, OnInit, ElementRef } from '@angular/core';
import { CommonService } from '../common.service';
import { KycserviceService } from './kycservice.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { SessionStorageService } from 'ngx-webstorage';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.css']
})
export class KycComponent implements OnInit {
  onFileSelected(event){
    console.log(event);
  }
  url: string = "http://valobit.io/valobit/kyc.php?token="+this.session.retrieve('token');
  urlSafe: SafeResourceUrl;

  
  kycForm: any;
  userkyc: any;
  constructor(private  commonService: CommonService, private spinner: NgxSpinnerService, public sanitizer: DomSanitizer, private kycserviceService:KycserviceService, private session: SessionStorageService , private formBuilder: FormBuilder, private routes: Router, private alertService: AlertService, private elementRef: ElementRef) { 
    this.kycForm = this.formBuilder.group({
      'name': ['', [Validators.required]],
       'mobile':  ['', [Validators.required]],
       'email': ['', Validators.compose([
        Validators.required,
        Validators.email
      ])],
       'country': ['', [Validators.required]],
       'ethAddress': ['', [Validators.required]],
    });
 }
 
  ngOnInit() {
    if(this.session.retrieve('token')){
      this.commonService.tokenValidity().then((res: any) => {
        this.spinner.hide();
        }).catch((err: any) => {     
            this.alertService.danger(err.message);
            this.spinner.hide();
            this.routes.navigate(['/login']);
      });
    }else{      
      this.routes.navigate(['/login']);
    }
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.kycserviceService.kycdetail().then((res: any)  => {
      this.spinner.hide();
    if(res.status){
      this.userkyc = res;
    }
  });
  }
  submit() {
    if(!this.kycForm.valid){
      Object.keys(this.kycForm.controls).forEach(field => { 
        const control = this.kycForm.get(field);           
        control.markAsDirty({ onlySelf: true }); 
      });
      return;
    }
    // this.spinner.show();
    //   this.kycserviceService.check(this.kycForm.value.idtype, this.kycForm.value.name, this.kycForm.value.lastName, this.kycForm.value.idcard,).then((res: any) => {
    //     this.spinner.hide();
    //     if(res.status){
    //       this.routes.navigate(['main/purchaseorder',], { queryParams: { 'address': res.walletaddress, 'value': res.totbtc } });
    //     }else{
    //       this.spinner.hide();
    //       this.alertService.danger('Unautherized User');
    //     }
    //   }).catch((err: any) => {this.alertService.danger(err.message);  this.spinner.hide(); }); 
  }
  uploadFile($event){
    console.log($event.target.files[0]);
  }
}
